import { useCallback } from 'react';

import { useActorRef } from '@xstate5/react';

import { useGetLocationPermissionStatusActor, useRequestLocationPermissionActor } from './actors';
import { permissionsMachine, type PermissionsMachineImplementations } from './permissions.machine';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitPermissionsMachine = (params: UseInitPermissionsMachineParams) => {
  const { isLocationPrimerEnabled, implementations } = params;

  // ─── Actors ──────────────────────────────────────────────────────────

  const getLocationPermissionStatus = useGetLocationPermissionStatusActor();
  const requestLocationPermission = useRequestLocationPermissionActor();

  // ─── Guards ──────────────────────────────────────────────────────────

  const checkIfLocationPrimerEnabled = useCallback(
    () => isLocationPrimerEnabled,
    [isLocationPrimerEnabled],
  );

  // ─────────────────────────────────────────────────────────────────────

  return useActorRef(
    permissionsMachine.provide({
      ...implementations,
      actors: {
        ...implementations?.actors,
        getLocationPermissionStatus,
        requestLocationPermission,
      },
      guards: {
        ...implementations?.guards,
        checkIfLocationPrimerEnabled,
      },
      actions: {
        ...implementations?.actions,
      },
    }),
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseInitPermissionsMachineParams = {
  isLocationPrimerEnabled: boolean;
  implementations?: PermissionsMachineImplementations;
};
